import React from "react";
import "./styles.scss";
import Navigation from "../Navigation";
import useDeviceDetect from "../../hook/useDeviceDetect";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { useTheme } from "../../hook/useThemes";
export default function SimulatingContent() {
  const { isMobile } = useDeviceDetect();
  const { lang } = useTheme();
  return (
    <div className="wrap-content-SimulatingContent">
      {!isMobile && <Navigation isHiddenMenu />}
      {isMobile && (
        <div className="wrapper-logo">
          <Link to={`/${window.location.search}`}>
            <img src={logo} className="logo" alt="" />
          </Link>
        </div>
      )}

      <div className="content-SimulatingContent">
        <div className="content">
          <p>
            {lang?.content_simulating ||
              "We’re experiencing some technical difficulties. Our team is on it, and we'll have things running smoothly soon. Please try again in a bit. Thanks for your patience!"}
          </p>
        </div>
      </div>
    </div>
  );
}